export default {
    // EntityTypeSelector - Entity type labels
    entityUnitDriverSelector_drivers: "Drivers",
    entityUnitDriverSelector_units: "Units",

    // ContentArea - "All" option selected messages
    entityUnitDriverSelector_allDriverSelected: "All drivers selected",
    entityUnitDriverSelector_allUnitSelected: "All units selected",

    // OptionSelector - Option labels for all/entities/tags
    entityUnitDriverSelector_allDriver: "All Drivers",
    entityUnitDriverSelector_allUnit: "All Units",
    entityUnitDriverSelector_singleDriver: "Single Drivers",
    entityUnitDriverSelector_singleUnit: "Single Units",
    entityUnitDriverSelector_tags: "Tags",

    // InactiveDriversToggle - Toggle options and label
    entityUnitDriverSelector_includeInactiveDrivers: "Include Inactive drivers",
    entityUnitDriverSelector_notOption: "No",
    entityUnitDriverSelector_yesOption: "Yes",

    // EntityTagPickerSingle - Search, inactive label, no items
    entityTagPicker_inactive: "Inactive",
    entityTagPicker_noItemsFound: "No items found",
    entityTagPicker_search_driver: "Select drivers or search by name",
    entityTagPicker_search_unit: "Select units or search by name",
};
